import styles from './PillarItem.module.sass';
import Image from "next/image";
import Arrow_SVG from "@/components/svg/Global/Arrow_SVG";
import cn from "classnames";
const PillarItem = ({ pillarIndex, pillar, selectedPillar, ...props}) => {

	return (
			<div className={cn(
					styles.pillar_item,
					{[styles.clicked]: pillarIndex === selectedPillar},
					{[styles.unselected]: pillarIndex !== selectedPillar},
					{[styles.previous]: pillarIndex === selectedPillar - 1},
					'pillar',
				)}
			     {...props}
			>
				<div className={cn(styles.upper_part, 'custom_pointer')}>
					<div className={styles.background}></div>
					<div className={styles.left}>
						<div className={styles.icon}>
							<svg xmlns="http://www.w3.org/2000/svg" width="38" height="36" viewBox="0 0 38 36" fill="none" className={styles.icon__background}>
								<path d="M38 6.11765V28.6588H36.7799V31.1059H35.5597V32.3294H33.1208V33.5529H31.9006V34.7765H30.6805V36H7.31949V34.7765H6.09935V33.5529H4.87921V32.3294H2.44028V31.1059H1.22014V28.6588H0L0 6.11765H1.22014L1.22286 3.67059H2.44572V2.44706H4.89144V1.22353H7.33716V0L30.6628 0V1.22353H33.1086V2.44706H35.5543V3.67059H36.7771L36.7799 6.11765H38Z"
								      fill="#737361"/>
							</svg>
							<div className={styles.icon__img}>
								<Image src={pillar.icon} alt={pillar.alt} fill sizes={'4rem'}/>
							</div>
						</div>
						<span className={styles.text}>{pillar.name}</span>
					</div>
					<Arrow_SVG color={'#0D422E'} className={styles.arrow}/>
				</div>

				<div className={styles.lower_part}>
					<Arrow_SVG color={'#0D422E'} className={styles.arrow}/>
					<span className={styles.text} dangerouslySetInnerHTML={{__html: pillar.text}}/>
				</div>
			</div>
	)
}
export default PillarItem;